<div id="content" class="allcp-form chat-content" ng-controller="ChatController" ng-init="all()">
	<div ng-include="'modules/company/menus/order_menu.html'"></div>
	<div id="frame">
		<div id="sidepanel">
			<div id="contacts">
				<div class="sidebar-head" id="eRightPanel" ng-if="!sWorker" style="    min-width: 280px;max-width: 330px;width: 40%;">
					<div class="sidebar-header p10" style="display:block;height: 30px;">
						<strong>Driver(s) </strong>
					</div>
			
					<div class="sidebar-header p10" style="display:block">
						<input type="text" ng-model="filterData.searchTerm" placeholder="Search Driver(s)" class="form-control">
					</div>
			
					<ul class="sidebar-menu-tab mn pn">
						<li style="width: 50%;" ng-class="selectedStatus == 'online' ? 'active' : '' " ng-click="setStatus('online')">
							<a href="#">
								<h5 class="mbn mtn">{{ getWorkerStatus('online', filterData.searchTerm).length }}</h5>
								<small>Online</small>
							</a>
						</li>
						<li style="width: 50%;" ng-class="selectedStatus == 'offline' ? 'active' : '' " ng-click="setStatus('offline')">
							<a href="#">
								<h5 class="mbn mtn">{{ getWorkerStatus('offline', filterData.searchTerm).length }}</h5>
								<small>Offline</small>
							</a>
						</li>
					</ul>
				</div>
				<ul>
					<li class="contact" 
						ng-repeat="item in getWorkerStatus(selectedStatus, filterData.searchTerm) | orderBy:'conversation.last_message.created_at':true " 
						ng-click="get((item.conversation ? item.conversation.id : 0), item)" 
						ng-class="{ 'active': selectedConversation.id == item.id, 'offline' : !item.status }">
						<div class="wrap">
							<span class="contact-status online" ng-if="item.status"></span>
							<img ng-src="https://s3.us-west-2.amazonaws.com/hodxpress/{{ item.profile_photo }}">
							<div class="meta">
								<p class="name">
									{{ item.full_name }}
									<span class="label label-danger counter" ng-if="item.conversation && item.conversation.new_message > 0" style="border-radius: 50%;">
										{{ item.conversation.new_message }}
									</span>
								</p>
								<p class="preview" ng-if="!item.conversation">No Conversation</p>
								<p class="preview" ng-if="item.conversation">{{ item.conversation.last_message ? item.conversation.last_message.body : '-' }}</p>
								<small class="preview" ng-if="item.conversation">{{ item.conversation.last_message ? item.conversation.last_message.created_at : item.conversation.created_at | amDateFormat:'MM/DD/YYYY hh:mm A' }}</small>
							</div>
						</div>
					</li>
					<li class="contact" ng-if="data.conversations.length == 0">
						<div class="wrap" ng-class="{ 'active' ? $index == 0 }">
							<div class="meta">
								<p class="name">Not Found</p>
								<p class="preview">Conversation not found</p>
							</div>
						</div>
					</li>
				</ul>
			</div>
		</div>
		<div class="content" ng-if="conversation">
			<div class="contact-profile">
				<img ng-src="https://s3.us-west-2.amazonaws.com/hodxpress/{{ conversation.worker.profile_photo }}">
				<p>{{ conversation.worker.full_name }}</p>
			</div>
			<div class="messages" scroll-to-bottom="conversation.messages">
				<ul>
					<li ng-repeat="item in conversation.messages" ng-class="!item.user ? 'sent' : 'replies'">
						<img src="https://s3.us-west-2.amazonaws.com/hodxpress/nobody.jpg" alt="" ng-if="item.user"/>
						<img ng-src="https://s3.us-west-2.amazonaws.com/hodxpress/{{ item.worker.profile_photo }}" alt="" ng-if="item.worker"/>
						<div class="message-body">
							{{ item.body }}
							<div ng-if="item.file">
								<a class="fs21" 
									href="https://s3.us-west-2.amazonaws.com/hodxpress/{{ item.file }}"
									target="__BLANK">
								<i class="fa fa-file fs24"></i>
								File
								</a>
							</div>
						</div>
						<span>{{ item.created_at | amDateFormat:'MM/DD/YYYY hh:mm A' }}</span>
					</li>
				</ul>
			</div>
			<div class="message-input">
			
				<div class="wrap">
					<div class="upload-chat">
						<div class="logo_upload" ng-repeat="item in w9file.queue" style="width:50%">
							<div class="progress" ng-if="proccessProfile">
								<div 
									class="progress-bar progress-bar-success progress-bar-striped active" 
									role="progressbar" 
									aria-valuenow="60" 
									aria-valuemin="0" 
									aria-valuemax="100" 
									ng-style="{ 'width': item.progress + '%' }"
									>
								</div>
							</div>
						</div>
						<div ng-if="formData.file">
							<a class="fs21 center" 
								href="https://s3.us-west-2.amazonaws.com/hodxpress/{{ formData.file }}"
								target="__BLANK">
							<i class="fa fa-file fs24"></i>
							{{ formData.file }}
							</a>
						</div>
					</div>

					<textarea type="text" 
						name="message" 
						id="messageInput" 
						ng-model="formData.message" 
						ng-enter="sendMessage(chatMessage)" 
						placeholder="Write your message..."></textarea>

					<button class="hod-button blue" ng-click="sendMessage(chatMessage)">
						<i class="fa fa-paper-plane" style="font-size: 21px;" aria-hidden="true"></i>
					</button>
					<div class="upload-chat">
						<span class="btn btn-outline btn-file" style="float: right;border: none;width: 100px;padding: 12px 0;cursor: pointer;">
							<span class="fileupload-new">Select File</span>
							<input type="file" nv-file-select uploader="chatFile">
						</span>
						<div class="logo_upload" ng-repeat="item in w9file.queue" style="width:50%">
							<div class="progress" ng-if="proccessProfile">
								<div 
									class="progress-bar progress-bar-success progress-bar-striped active" 
									role="progressbar" 
									aria-valuenow="60" 
									aria-valuemin="0" 
									aria-valuemax="100" 
									ng-style="{ 'width': item.progress + '%' }"
									>
								</div>
							</div>
						</div>
						<div ng-if="formData.file">
							<a class="fs21 center" 
								href="https://s3.us-west-2.amazonaws.com/hodxpress/{{ formData.file }}"
								target="__BLANK">
							<i class="fa fa-file fs24"></i>
							{{ formData.file }}
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
    <div ng-include="'modules/company/chat/new.html'"></div>
</div>